/**
 * Keys used in the size guide
 */

  export default {
    BABIES: 'babies',
    BELTS: 'belts',
    BOTTOMS: 'bottoms',
    BOYS: 'boys',
    CAPS: 'caps',
    CHEST: 'chest',
    CM: 'cm',
    FOOT: 'foot',
    GENDER: 'gender',
    GIRLS: 'girls',
    GUIDE: 'guide',
    HIP: 'hip',
    INCH: 'inch',
    INSEAM: 'inseam',
    LENGTH: 'length',
    MEN: 'men',
    SHOES: 'shoes',
    SIZE: 'size',
    SIZERANGE: 'sizeRange',
    SIZEWAIST: 'sizeWaist',
    TOPS: 'tops',
    UNIT: 'unit',
    WAIST: 'waist',
    WOMEN: 'women',
  };

